export const TOUR_TARGETS = Object.freeze({
  NAV: Object.freeze({
    INBOX: "nav-inbox",
    MY_WORK: "nav-my-work",
    LEAD_COMMAND_CENTRE: "nav-lead-command-centre",
    HELP: "nav-help",
  }),
  MY_WORK: Object.freeze({
    HEADER: "my-work-header",
    SUMMARY: "my-work-summary",
    TABS: "my-work-tabs",
    FILTERS: "my-work-filters",
    ACTIONS: "my-work-actions",
    LIST: "my-work-list",
  }),
  INBOX: Object.freeze({
    SHELL: "inbox-shell",
    CONVERSATIONS: "inbox-conversations",
    CONVERSATION_HEADER: "inbox-conversation-header",
    MESSAGES: "inbox-messages",
    COMPOSER: "inbox-composer",
    DETAILS: "inbox-details",
  }),
  LCC: Object.freeze({
    HEADER: "lcc-header",
    VIEW_MODE: "lcc-view-mode",
    METRICS: "lcc-metrics",
    FILTERS: "lcc-filters",
    VIEW_CONTROLS: "lcc-view-controls",
    RESULTS: "lcc-results",
  }),
});

export function tourTargetSelector(target) {
  return `[data-tour="${target}"]`;
}
